import { SupportTicketStatusAPI } from '@business/api/support_ticket_status';
import { SupportTicketStatusResponse, SupportTicketStatusId } from '@business/entities/support_ticket_status';
import { handleMessage, requestMessage } from '@business/messages';
import { BaseBloc } from '@core/utils/bloc';
import { R } from '@core/utils/r';
import { Repository } from '@core/utils/repository';
import { showDeleteConfirmation } from '@modules/common';
import { map, switchMap } from 'rxjs/operators';

export class SupportTicketStatusBloc extends BaseBloc {
  private readonly statusRepo = new Repository<SupportTicketStatusResponse>({
    getItemId: item => item.id,
  });

  readonly statuses$ = this.statusRepo.items$.pipe(map(items => R.sortBy(items, 'menuOrder')));
  readonly selectSupportTicketStatus = this.statusRepo.selectItem;

  onReset() {
    this.statusRepo.reset();
  }

  fetchSupportTicketStatuses = () => {
    return SupportTicketStatusAPI.fetchSupportTicketStatuses().pipe(this.statusRepo.ops.reset(), handleMessage({ error: requestMessage('fetch_general_error') }));
  };

  createSupportTicketStatus = (data: Partial<SupportTicketStatusResponse>) => {
    return SupportTicketStatusAPI.createSupportTicketStatus(data).pipe(
      this.statusRepo.ops.upsertMany(item => ({ item })),
      handleMessage({
        type: requestMessage('create_task_status'),
      }),
    );
  };

  updateSupportTicketStatus = (id: SupportTicketStatusId, data: Partial<SupportTicketStatusResponse>) => {
    return SupportTicketStatusAPI.updateSupportTicketStatus(id, data).pipe(
      this.statusRepo.ops.upsertMany(item => ({ item })),
      handleMessage({
        type: requestMessage('update_task_status'),
      }),
    );
  };

  deleteSupportTicketStatus = (id: SupportTicketStatusId) => {
    return showDeleteConfirmation('Delete Status', 'Do you really want to remove this status?').pipe(
      switchMap(() => SupportTicketStatusAPI.deleteSupportTicketStatus(id)),
      this.statusRepo.ops.removeOne(() => id),
      handleMessage({
        type: requestMessage('delete_task_status'),
      }),
    );
  };

  sortSupportTicketStatus = (ids: string[]) => {
    return SupportTicketStatusAPI.sortSupportTicketStatus(ids).pipe(
      this.statusRepo.ops.upsertMany(item => ({ item })),
      handleMessage({
        type: requestMessage('update_task_status'),
      }),
    );
  };
}
